import { GridSize } from '@mui/material';
import { MeasurementData } from 'features/weather/types';
import { TraceHistory } from '../../../types';

export type TraceHistoryMap = {
  [key: number]: TraceHistory[];
};

export type TraceCountMap = {
  [key: number]: number;
};

export type TraceHistoryFilters = {
  toDate: Date;
  fromDate: Date;
  analyzerId: number;
  snapshotId: number;
  savedAnalyzerId: number;
  savedSnapshotId: number;
};

export type SavedTraceHistoryIds = { snapshotId: number; analyzerId: number };

export type ActiveSettingsKey = 1 | 2;

export type SliderMark = { value: number };

export interface HistoryState {
  traceHistory: TraceHistoryMap | null;
  traceCount: TraceCountMap;
  noDataFlag: boolean;
  isHistoryLoading: boolean;
  multiHistory: boolean;
  showMarkerHistory: boolean;
  smallestTraceHistoryLength: number;
  graphSize: GridSize;
  hideDetectorNames: boolean;
}

export type TraceHistoryAction = {
  type:
    | 'RESET-STATE'
    | 'LOAD-HISTORY'
    | 'HISTORY-COUNT-LOADED'
    | 'HISTORY-LOADED'
    | 'TOGGLE-HIDE-DETECTOR-NAMES'
    | 'TOGGLE-MARKER-HISTORY';
  payload?: any;
};

export interface WeatherConstraintFromQueryString {
  measurement: MeasurementData;
  level: number;
  greaterThan: boolean;
}

export interface QueryResults {
  hasQueryString: boolean;
  startTime: null | string;
  endTime: null | string;
  snapshotIdToLoad: number;
  analyzerIdToLoad: number;
  traceIndex: number;
  weather: boolean;
  forecast: boolean;
  weatherConstraints: WeatherConstraintFromQueryString[];
  dishIdToLoad: number;
  redirectPath: string | null;
}

export enum PlayStatus {
  ForwardPaused,
  BackwardPaused,
  Forward,
  Backward,
}
